import Loading from './components/Loading';
import { redirectToAdmin } from './actions/folio-actions';
import createBrowserHistory from 'history/createBrowserHistory';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect'
const history = createBrowserHistory();


const locationHelper = locationHelperBuilder({});

export const UserIsAuthenticated = connectedReduxRedirect({
  wrapperDisplayName: 'UserIsAuthenticated',
  AuthenticatingComponent: Loading,
  allowRedirectBack: true,
  redirectPath: (state, ownProps) =>
      locationHelper.getRedirectQueryParam(ownProps) || '/login',
  authenticatingSelector: ({ firebase: { auth, profile, isInitializing } }) =>
      !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
      auth.isLoaded && !auth.isEmpty,
  redirectAction: newLoc => (dispatch) => {
    history.replace(newLoc);
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  },
});

export const UserIsNotAuthenticated = connectedReduxRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  AuthenticatingComponent: Loading,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
      '/admin/projects',
  authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
      !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
      auth.isLoaded && auth.isEmpty,
  redirectAction: newLoc => (dispatch) => {
    dispatch(redirectToAdmin());
  },
});



// WEBPACK FOOTER //
// ./src/auth.js